import { gql } from 'apollo-angular';

const GET_DOWNLOAD_LID_URL = gql`
  query GetDownloadLIDReport($rfpId: Long!) {
    downloadLIDReport(rfpId: $rfpId) {
        url
    }
  }
`;

export default GET_DOWNLOAD_LID_URL;